/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { ChangeEvent, FC } from "react";
import { Control, Controller } from "react-hook-form";

import TestIds from "../../../testIds";
import InputFormControl from "../../form-controls/InputFormControl/InputFormControl";

import { EUnitPriceFields, TUnitPriceFormData } from "./types";

export interface IFormControlReasonNoteProps {
  control: Control<TUnitPriceFormData>;
  validateField: (errorMessage: string) => (value?: string) => string | true;
  clearError: () => void;
}

export const FormControlReasonNote: FC<IFormControlReasonNoteProps> = ({
  control,
  validateField,
  clearError,
}) => (
  <Controller
    name={EUnitPriceFields.ReasonNote}
    control={control}
    rules={{ validate: validateField("Please enter a comment") }}
    render={({ field, fieldState: { error } }) => (
      <InputFormControl
        id={EUnitPriceFields.ReasonNote}
        data-testid={TestIds.components.forms.unitPriceForm.commentsField}
        variant="farmlands2.0_default"
        labelColor="secondary"
        label="Comments"
        placeholder="Comments"
        error={!!error}
        required
        value={field.value || ""}
        errorMessage={error?.message}
        inputProps={{
          autoComplete: "off",
          onChange: (event: ChangeEvent<HTMLInputElement>) => {
            field.onChange(event);
            if (error) {
              clearError();
            }
          },
          onBlur: field.onBlur,
          maxLength: 200,
        }}
        hint={`${field.value?.length || 0}/200 characters`}
      />
    )}
  />
);
